import AsyncStorage from '@react-native-async-storage/async-storage';
import { useCallback, useEffect, useState } from 'react';

const DEFAULT_SHOW_DELAY_MS = 1200;

/**
 * One-time callout shown once per install, keyed by storageKey.
 * Delayed so it doesn't compete with initial screen load.
 */
export function useOneTimeCallout(storageKey: string, showDelayMs = DEFAULT_SHOW_DELAY_MS) {
  const [isCalloutVisible, setIsCalloutVisible] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const timer = setTimeout(async () => {
      try {
        const seen = await AsyncStorage.getItem(storageKey);
        if (!cancelled && seen === null) {
          setIsCalloutVisible(true);
        }
      } catch (err) {
        console.warn('[useOneTimeCallout] storage read failed:', err);
      }
    }, showDelayMs);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [storageKey, showDelayMs]);

  const dismissCallout = useCallback(() => {
    setIsCalloutVisible(false);
    AsyncStorage.setItem(storageKey, 'true').catch((err) =>
      console.warn('[useOneTimeCallout] storage write failed:', err)
    );
  }, [storageKey]);

  return { isCalloutVisible, dismissCallout };
}
